import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import YearlyForecast from './yearly-forecast';
import CosmicProfile from './cosmic-profile';

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps.report != this.props.report) {
            return true;
        }

        return false;
    }

    render({ report }) {
        let Report = null;

        if (report && report.product_code) {
            if (report.product_code == 'cosmic-profile-report-redux') {
                Report = CosmicProfile;
            } else {
                Report = YearlyForecast;
            }

            return (
                <astrology-report>
                    <Report />
                </astrology-report>
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    report: state.report,
});

export default connect(mapStateToProps)(Component);
